import { hbs } from 'ember-cli-htmlbars';
export default hbs("<Dashboard @queryParamsValues={{this.queryParamsValues}} />")